// src/redux/actions/salesActions.js
import {
    CREATE_SALES_DEMO_CUST_OR_PRACT_REQUEST,
    CREATE_SALES_DEMO_CUST_OR_PRACT_SUCCESS,
    CREATE_SALES_DEMO_CUST_OR_PRACT_FAILURE,
    CLEAR_CREATE_SALES_DEMO_CUST_OR_PRACT
} from '../../../../Constants/actionTypes';
import { createCustomerDemoSession,createInternalDemoSession } from '../../../../Constants/apiService'


// Fetch Sales Request Action
export const createDemoSessionRequest = () => ({
    type: CREATE_SALES_DEMO_CUST_OR_PRACT_REQUEST,
});

// Fetch Sales Success Action
export const createDemoSessionSuccess = (salesData) => ({
    type: CREATE_SALES_DEMO_CUST_OR_PRACT_SUCCESS,
    payload: salesData,

});

// Fetch Sales Failure Action
export const createDemoSessionFailure = (error) => ({
    type: CREATE_SALES_DEMO_CUST_OR_PRACT_FAILURE,
    payload: error,
});


// Action to clear the ExistingDemoSession
export const clearcreateDemoSession = () => ({
    type: CLEAR_CREATE_SALES_DEMO_CUST_OR_PRACT,
});

// Thunk Action Creator for Fetching Sales
export const createCustomerDemoSessionAct = (id, params) => {
   console.log(params)
    return async (dispatch, getState) => {
        dispatch(createDemoSessionRequest());

        const state = getState();
        const accessToken = state.auth.accessToken;


        try {
            const data = await createCustomerDemoSession(accessToken,params,id);
            console.log(data)
             // Add custom field to the response
             const responseWithType = { ...data, type: 'customer' };
            dispatch(createDemoSessionSuccess(responseWithType));
        } catch (error) {
            let errorMessage;
            if (error.message === 'Failed to fetch' || error.message.includes('NetworkError')) {
                errorMessage = 'Server is currently down. Please try again later.';
            } else {
                errorMessage = error.message;
            }
            dispatch(createDemoSessionFailure(errorMessage));
        }
    };
};






// create internal demo session
export const createInternalDemoSessionAct = (id, params) => {
    return async (dispatch, getState) => {
        dispatch(createDemoSessionRequest());
        console.log(params)
        console.log(id)
        const state = getState();
        const accessToken = state.auth.accessToken;


        try {
            const data = await createInternalDemoSession(accessToken,params,id);
            console.log(data)
            const responseWithType = { ...data, type: 'internal' };
            dispatch(createDemoSessionSuccess(responseWithType));
        } catch (error) {
            let errorMessage;
            if (error.message === 'Failed to fetch' || error.message.includes('NetworkError')) {
                errorMessage = 'Server is currently down. Please try again later.';
            } else {
                errorMessage = error.message;
            }
            dispatch(createDemoSessionFailure(errorMessage));
        }
    };
};